// TODO: this will be deprecated at some point
type APIMessage = {
  kind: 'APIMessage';
  code: string;
  source: string;
  text: string;
};

type JSONAPIMessage = {
  code: string;
  source: string;
  text: string;
};

function fromJSON(jsonAPIMessage: JSONAPIMessage): APIMessage {
  return {
    kind: 'APIMessage',
    code: jsonAPIMessage.code,
    source: jsonAPIMessage.source,
    text: jsonAPIMessage.text,
  };
}

// These are the five most common warnings. None of them are actionable.
// We hid them as part of this ticket https://shippo.atlassian.net/browse/ENG-35089
const hiddenCarrierMessages: Partial<Record<string, Set<string>>> = {
  DHLExpress: new Set([
    "Shippo's DHL Express master account doesn't support shipments to inside of the US",
  ]),
  ShippoCommon: new Set([
    'Shipment origin or destination state is out of the service area for LSO.',
  ]),
  UPS: new Set([
    'RatedShipmentAlert: Ship To Address Classification is changed from Commercial to Residential',
    'Shipment origin is out of service area for UPS Master account from CA',
    'RatedShipmentAlert: Your invoice may vary from the displayed reference rates',
  ]),
};

export const messageIsHidden = (message: { source: string; text: string }): boolean => {
  return !!hiddenCarrierMessages[message.source]?.has(message.text);
};

export const messageIsVisible = (message: { source: string; text: string }): boolean =>
  !messageIsHidden(message);

export default APIMessage;
export { fromJSON, JSONAPIMessage, APIMessage };
